import * as types from '../actions/action-types';

export function appsByType(state = {developer: {items: []}, pending: {items: []}, pendingInMarket: {items: []}, single: {items: []}, myApps: {items: []}}, action) {
  switch (action.type) {
    case types.RECEIVE_APPS_BY_TYPE:
      return {...state, [action.appsType]: {items: action.items, receivedAt: action.receivedAt, isFetching: false}};

    case types.REQUEST_APPS_BY_TYPE:
      return {...state, [action.appsType]: {items: [], isFetching: true}};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/apps-by-type.js